import { useEffect, useRef } from "react";
import { createScope } from "animejs";
import { shouldReduceMotion } from "../utils/motion";

const useAnimeScope = (rootRef, setup, deps = []) => {
  const scopeRef = useRef(null);

  useEffect(() => {
    if (!rootRef.current || shouldReduceMotion()) return undefined;

    scopeRef.current = createScope({ root: rootRef }).add(setup);

    return () => {
      scopeRef.current?.revert();
      scopeRef.current = null;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return scopeRef;
};

export default useAnimeScope;
